// ./store.js
import {
  createStore,
  applyMiddleware,
  combineReducers
} from 'redux';
import {
  createForms // optional
} from 'react-redux-form';
import thunk from 'redux-thunk';
import { DEVICE_MODE } from '../enums/device-mode';


// only for tests
const initialUserState = {
  firstName: '',
  lastName: 10
};

const initialTimeSettings = {
  0: [],
  1: [],
  2: [],
  3: [],
  4: [],
  5: [],
  6: []
}

const createDevice = {
  mode: DEVICE_MODE.INPUT,
  isActive: false,
  input: 0,
  reactionTime: '00:00',
  holdingTime: '00:00',
  timeSettings: initialTimeSettings,
  tmpTime: {
    from: '00:00',
    to: '00:00'
  },
  temp1: '',
  temp2: '',
  hydrostat1: '',
  hydrostat2: ''
}

const createAnalogDevice = {
  isActive: false,
  voltageUp: 0,
  voltageDown: 0,
  input: 0
}

const createRotation = {
  redundancy: 0,
  numberOfAirConditioners: 0,
  numberOfActiveAirConditioner: 0,
  startRedundancy: '00:00',
  cycleRedundancy: '00:00',
  upTempThreash: 0,
  downTempThreash: 0,
  sensor: 0,
  airConditioners: [],

}

const createSensorAlarm = {
  isActive: 0,
  valueUp: 0,
  valueDown: 0,
  hysteresis: 0,
  reactionTime: 0
}

const createInputAlarm = {
  reactionTime: 0,
  isActive: 0,
}

const creatAnalogAlarm = {
  reactionTime: 0,
  voltageUpState: 0,
  valueUp: 0,
  voltageDownState: 0,
  valueDown: 0
}

const createAlarms = {
  temp1: createSensorAlarm,
  temp2: createSensorAlarm,
  temp3: createSensorAlarm,
  temp4: createSensorAlarm,
  temp5: createSensorAlarm,
  temp6: createSensorAlarm,
  humidity1: createSensorAlarm,
  input1: createInputAlarm,
  input2: createInputAlarm,
  input3: createInputAlarm,
  input4: createInputAlarm,
  input5: createInputAlarm,
  input6: createInputAlarm,
  analog2: creatAnalogAlarm,
}

const createPhones = {
  sim: '',
  phones: [],
  tmpPhone: '',
  tmpName: ''
}
const createEmails = {
  emails: [],
  adminEmail: '',
  tmpEmail: '',
  tmpName: ''
}

const createNames = {
  relays: {
    relay1: 'r1',
    relay2: 'r2',
    relay3: 'r3',
    relay4: 'r4',
    relay5: 'r5',
  },
  irda: {
    irda1: 'i1',
    irda2: 'i2',
    irda3: 'i3',
    irda4: 'i4',
  },
  humidity: {
    humidity1: 'h1',
  },
  temperature: {
    temp1: 't1',
    temp2: 't2',
    temp3: 't3',
    temp4: 't4',
    temp5: 't5',
  },
  inputs: {
    input1: 'i1',
    input2: 'i2',
    input3: 'i3',
    input4: 'i4',
    input5: 'i5',
    input6: 'i6',
  },
  analogs: {
    analog1: 'analog1',
    analog2: 'analog2'
  }
}

const createMotbus = {
  dataRate: 9600,
  parity: 0,
  dataBits: 7,
  stopBits: 0,
  address: ''
}

const createGeneral = {
  infoSendingTime: 40
}

const appReducer = combineReducers({

  ...createForms({
    user: initialUserState,
    relay1: createDevice,
    relay2: createDevice,
    relay3: createDevice,
    relay4: createDevice,
    relay5: createDevice,
    irda1: createDevice,
    irda2: createDevice,
    irda3: createDevice,
    irda4: createDevice,
    analog1: createAnalogDevice,
    analog2: createAnalogDevice,
    rotation: createRotation,
    alarms: createAlarms,
    phones: createPhones,
    emails: createEmails,
    names: createNames,
    modbus: createMotbus,
    general: createGeneral,
    'manual-settings': {
      analog1Value: 0
    }
  }),
})

export type AppState = ReturnType<typeof appReducer>;

const store = createStore(appReducer, applyMiddleware(thunk));

export default store;
